import { Legal } from 'src/models/Legal';
import { formatAddressLines } from './addressUtils';

export const getVatNumber = (creditor: Legal): string => creditor.numeroTVA ?? creditor.vatNumber ?? '';

export const hasAnyLegalInfo = (legal?: Legal | null, opts?: { showEmail?: boolean; showRcs?: boolean }): boolean => {
    if (!legal) {
        return false;
    }
    const showEmail = opts?.showEmail ?? true;
    const showRcs = opts?.showRcs ?? true;
    const addr = formatAddressLines(legal.address);
    const vat = getVatNumber(legal);
    const rcs = legal.registreCommerceNumero ?? '';
    return (
        Boolean(legal.companyName) ||
        addr.length > 0 ||
        Boolean(vat) ||
        (showRcs && Boolean(rcs)) ||
        (showEmail && Boolean(legal.email))
    );
};